import { Icon } from '../../Elements'

const ListGroup = ({ className, title, items }: ListGroupInterface) => {
  return (
    <>
      {title}
      <ul
        className={`${
          className ?? ""
        } text-xs font-bold flex flex-col justify-center items-center gap-2`}
      >
        {items?.map((n, i) => (
          <li className={`flex gap-1 items-center n  w-full`} key={i}>
            <Icon
              icon="rayteb-android-wifi"
              className="text-primary w-5 h-5  text-sm"
            />
            <div>
              {n.title}{" "}
              {n.items ? (
                <>
                  <ul className="px-4 ">
                    {n.items.map((x, index) => (
                      <li className="text-secondary my-2" key={index}>
                        {x.title}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                ""
              )}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}

export default ListGroup
